import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";

/**
 * Industrial-CTA-Band (TES-967, D5) nach Stitch-Mock screen-12 —
 * Deep-Blue-Fläche mit weichen Akzent-Orbs + Dual-CTA (Safety-Yellow primär).
 */
export function LandingCta() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden bg-brand py-24 text-white">
      {/* Soft accent orbs */}
      <div className="pointer-events-none absolute inset-0 opacity-20" aria-hidden="true">
        <div className="absolute right-0 top-0 h-[600px] w-[600px] rounded-full bg-secondary blur-[120px]" />
        <div className="absolute bottom-0 left-0 h-[400px] w-[400px] rounded-full bg-primary-fixed-dim blur-[100px]" />
      </div>

      <div className="relative z-10 mx-auto max-w-4xl space-y-8 px-4 text-center sm:px-6 lg:px-8">
        <h2 className="font-display text-3xl font-bold tracking-display sm:text-5xl">
          {t("landing.industrial.cta.title")}
        </h2>
        <p className="mx-auto max-w-2xl text-base text-white/80 sm:text-lg">
          {t("landing.industrial.cta.subtitle")}
        </p>
        <div className="flex flex-wrap justify-center gap-4 pt-2">
          <Button variant="action" size="lg" className="px-10 py-6 text-base" asChild>
            <Link to="/auth">{t("landing.industrial.cta.primary")}</Link>
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="border-white/30 bg-transparent px-10 py-6 text-base text-white hover:bg-white/10 hover:text-white"
            asChild
          >
            <Link to="/auth">{t("landing.industrial.cta.secondary")}</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
